module.exports = __webpack_public_path__ + "img/train.4e79d07c.png";